import React, { useState, useEffect, useCallback } from 'react';
import './saude.css';
import Sidebar from '../../components/Sidebar';
import { useLocation } from 'react-router-dom';
import { useInternals } from '../../context/internalContext';
import { useAuxiliaries } from '../../context/auxiliariesContext';
import { useUsers } from '../../context/usersContext';
import { toast } from 'react-toastify';
import Header from '../../components/header';
import Titulo from '../../components/Titulo/titulo';
import InternalPhoto from '../../components/InternalPhoto';
import BinaryFileLink from '../../components/BinaryFileLink';
import { BINARY_RESOURCES, hasBinaryField } from '../../utils/binaryFile';
import SearchInternal from '../../components/SearchInternal/SearchInternal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faClock } from '@fortawesome/free-solid-svg-icons';
import Modal from '../../components/modal';
import TooltipInfo from '../../components/TooltipInfo/';
import InternalDataSkeleton from '../../components/InternalDataSkeleton';
import useSubmitLock from '../../utils/useSubmitLock';

const initializeForwardingData = () => ({
  type: "",
  expertise: "",
  regulation: "",
  pending: true,
  reason: "",
  local: "",
  paid_by: "", //Estado ou Familia
  file: null, //pdf
  internal: "",
});

const Encaminhamento = () => {
  const location = useLocation();
  const { internalId } = location.state || {};
  const { effectiveUnitId, buildUnitReadParams } = useUsers();

  // --- Estados para os formulários ---
  const [forwardingData, setforwardingData] = useState(initializeForwardingData());
  const [listForwardingsRecords, setlistForwardingsRecords] = useState([]);

  const [editForwardingData, setEditForwardingData] = useState(null);

  // --- Estados para listas auxiliares ---
  const [expertise, setExpertise] = useState([]);


  // Funções de requisição (já existentes no contexto de internos)
  const {
    listInternals,
    createForwarding,
    listForwardings,
    updateForwarding,
  } = useInternals();

  // Funções auxiliares para carregar opções (vacinas, remédios, etc.)
  const {
    listExpertise,
    listTypeservicecare,
  } = useAuxiliaries();

  // --- Estados de busca e dados do interno selecionado ---
  const [internalDetails, setInternalDetails] = useState(null);
  const [isSelectingInternal, setIsSelectingInternal] = useState(false);
  const {
    isSubmitting: isCreatingForwarding,
    runWithSubmitLock: runCreateForwarding,
  } = useSubmitLock();
  const {
    isSubmitting: isUpdatingForwarding,
    runWithSubmitLock: runUpdateForwarding,
  } = useSubmitLock();

  // Abas: 'dados', 'vacina', 'medicamentos', 'externo', 'evolucao', 'exames'
  const [currentTab, setCurrentTab] = useState('encaminhamento');


  // --- Carrega dados auxiliares ---
  const loadAuxiliaryData = useCallback(async () => {
    try {
      const [expertiseData] = await Promise.all([
        listExpertise(),
        listTypeservicecare(),
      ]);

      setExpertise(expertiseData?.results || []);
    } catch (error) {
      console.error('Erro ao carregar dados auxiliares:', error);
    }
  }, [listExpertise, listTypeservicecare]);

  // --- Seleção de Interno e carregamento dos dados já cadastrados ---
  const handleInternalSelect = useCallback(async (internal) => {
    if (!internal?.id) {
      toast.error("Erro ao selecionar interno.");
      return;
    }

    try {
      const forwardingsRes = await listForwardings(internal.id);
      setInternalDetails(internal);
      setlistForwardingsRecords(
        Array.isArray(forwardingsRes?.results)
          ? forwardingsRes.results
          : Array.isArray(forwardingsRes)
            ? forwardingsRes
            : []
      );

    } catch (error) {
      console.error('Erro ao carregar dados do interno:', error);
      toast.error('Erro ao carregar dados do interno.');
    }
  }, [listForwardings]);


  useEffect(() => {
    if (internalId) {
      handleInternalSelect({ id: internalId });
    }
  }, [internalId, handleInternalSelect]);

  // --- Handlers para os inputs ---
  const handleForwardingChange = (e) => {
    const { name, type, value, files } = e.target;

    if (type === "file") {
      setforwardingData((prev) => ({
        ...prev,
        [name]: files[0] || null,
      }));
    } else {
      setforwardingData((prev) => ({
        ...prev,
        [name]:
          name === "pending"
            ? value === "true"
            : name === "expertise"
              ? (value ? parseInt(value, 10) : "")
              : value,
      }));
    }
  };

  // --- Funções de submissão ---
  const handleForwardingSubmit = async (e) => {
    e.preventDefault();
    await runCreateForwarding(async () => {
      if (!internalDetails?.id) {
        toast.warning("Nenhum interno selecionado.");
        return;
      }

      try {
        let payload;

        if (forwardingData.file) {
          payload = new FormData();
          Object.entries({ ...forwardingData, internal: internalDetails.id }).forEach(([key, value]) => {
            if (value !== null && value !== "") {
              payload.append(key, value);
            }
          });
        } else {
          payload = { ...forwardingData, internal: internalDetails.id };
        }

        await createForwarding(payload);

        const updated = await listForwardings(internalDetails.id);
        setlistForwardingsRecords(
          Array.isArray(updated?.results)
            ? updated.results
            : Array.isArray(updated)
              ? updated
              : []
        );

        setforwardingData(initializeForwardingData());
      } catch (err) {
        console.error("Erro ao salvar encaminhamento:", err);
        toast.error("Erro ao salvar encaminhamento.");
      }
    });
  };

  // Update
  const handleUpdateForwarding = async (e) => {
    e.preventDefault();
    await runUpdateForwarding(async () => {
      if (!editForwardingData?.id) return;

      try {
        const expertiseId =
          editForwardingData.expertise_id ??
          editForwardingData.expertise?.id ??
          editForwardingData.expertise ??
          null;

        let payload;

        if (editForwardingData.file instanceof File) {
          // Se o usuário selecionou um novo arquivo
          payload = new FormData();
          Object.entries({
            ...editForwardingData,
            expertise: expertiseId,
            internal: internalDetails.id,
          }).forEach(([key, value]) => {
            if (value !== null && value !== "") {
              payload.append(key, value);
            }
          });
        } else {
          // Atualização sem mexer no arquivo
          payload = {
            type: editForwardingData.type || "",
            expertise: expertiseId,
            regulation: editForwardingData.regulation || "",
            pending: !!editForwardingData.pending,
            reason: editForwardingData.reason || "",
            local: editForwardingData.local || "",
            paid_by: editForwardingData.paid_by || "",
            internal: internalDetails.id,
          };
        }

        await updateForwarding(editForwardingData.id, payload);

        const updated = await listForwardings(internalDetails.id);
        setlistForwardingsRecords(
          Array.isArray(updated?.results)
            ? updated.results
            : Array.isArray(updated)
              ? updated
              : []
        );

        setEditForwardingData(null);
      } catch (error) {
        console.error("Erro ao atualizar encaminhamento:", error);

        const backendMsg =
          error?.response?.data?.message ||
          JSON.stringify(error?.response?.data || "");
        toast.error(`Erro ao atualizar encaminhamento. ${backendMsg}`);
      }
    });
  };

  // --- Efeitos para carregar dados ---
  useEffect(() => {
    if (effectiveUnitId !== null && effectiveUnitId !== undefined && String(effectiveUnitId) !== '') {
      loadAuxiliaryData();
    }
  }, [loadAuxiliaryData, effectiveUnitId]);

  useEffect(() => {
    if (internalId) {
      const fetchInternalById = async () => {
        try {
          const response = await listInternals(buildUnitReadParams({ id: internalId }));
          const internalData = response?.results?.[0];

          if (internalData) {
            handleInternalSelect(internalData)
          }
        } catch (error) {
          console.error("Erro ao carregar interno pelo ID:", error);
          toast.error("Erro ao carregar interno.");
        }
      };

      fetchInternalById();
    }
  }, [internalId, handleInternalSelect, listInternals, buildUnitReadParams]);

  // --- Renderização das abas ---
  const renderForwardingTab = () => (
    <div className="forwarding-container">
      <form onSubmit={handleForwardingSubmit} className="evolucao-container">
        <div className="social-form-group-duplo">
          <div className="social-form-group">
            <label>Tipo de atendimento</label>
            <select
              name="type"
              value={forwardingData.type}
              onChange={handleForwardingChange}
              required
            >
              <option value="">Selecione</option>
              <option value="Exames">Exames</option>
              <option value="Consultas">Consultas</option>
            </select>
          </div>

          <div className="social-form-group">
            <label>Especialidade</label>
            <select
              name="expertise"
              value={forwardingData.expertise}
              onChange={handleForwardingChange}
              required

            >
              <option value="">Selecione</option>
              {expertise.map((ex) => (
                <option key={ex.id} value={ex.id}>
                  {ex.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="social-form-group-duplo">
          <div className="social-form-group">
            <label>Local <TooltipInfo text="Local a ser realizado." /></label>
            <input
              type="text"
              name="local"
              value={forwardingData.local}
              onChange={handleForwardingChange}
              required

            />
          </div>

          <div className="social-form-group">
            <label>Pago por<TooltipInfo text="Será pago pelo Estado(SUS) ou pela Família." /> </label>
            <select
              name="paid_by"
              value={forwardingData.paid_by}
              onChange={handleForwardingChange}
              required

            >
              <option value="">Selecione</option>
              <option value="SUS">SUS</option>
              <option value="FAMILIA">Família</option>
            </select>
          </div>
        </div>


        <div className="social-form-group-duplo">
          <div className="social-form-group">
            <label>Regulação <TooltipInfo text="Status da regulamentação. Ex: Se estar liberado pelo SUS." /> </label>
            <textarea
              name="regulation"
              value={forwardingData.regulation || ""}
              onChange={handleForwardingChange}
            />
          </div>
          <div className="social-form-group">
            <label>Motivo</label>
            <textarea
              name="reason"
              value={forwardingData.reason}
              onChange={handleForwardingChange}
            />
          </div>
        </div>
        <div className="social-form-group-duplo">
          <div className="social-form-group">
            <label >Pendente <TooltipInfo text="Se ainda nao foi realizado/autorizado, o pendente é SIM." /> </label>
            <select
              name="pending"
              value={forwardingData.pending ? "true" : "false"}
              onChange={handleForwardingChange}
            >
              <option value="true">Sim</option>
              <option value="false">Não</option>
            </select>
          </div>
          <div className="social-form-group">
            <label>Documento (PDF)</label>
            <input
              type="file"
              name="file"
              accept="application/pdf"
              onChange={handleForwardingChange}
            />
          </div>
        </div>

        <div className="social-form-group">
          <button
            type="submit"
            className="social-submit-button"
            disabled={isCreatingForwarding}
          >
            {isCreatingForwarding ? 'Salvando...' : 'Salvar Encaminhamento'}
          </button>
        </div>
      </form>

      {/* Timeline apenas se houver registros */}
      {Array.isArray(listForwardingsRecords) && listForwardingsRecords.length > 0 && (
        <div className="timeline">
          <h4>Histórico de Encaminhamentos</h4>
          <ul className="timeline-list">
            {listForwardingsRecords.map((rec) => (
              <li key={rec.id} className="timeline-item">
                <div className="timeline-date">
                  <FontAwesomeIcon icon={faClock} /> {new Date(rec.date).toLocaleDateString()}
                  <button
                    type="button"
                    className="edit-icon-button"
                    onClick={() => {
                      setEditForwardingData({
                        ...rec,
                        expertise:
                          rec.expertise_id ??
                          rec.expertise?.id ??
                          (typeof rec.expertise === 'number' || typeof rec.expertise === 'string'
                            ? rec.expertise
                            : ''),
                        pending: !!rec.pending,
                      });
                    }}
                  >
                    <FontAwesomeIcon icon={faPen} />
                  </button>
                </div>
                <div className="timeline-content">
                  <p><strong>Tipo:</strong> {rec.type || '—'}</p>
                  <p><strong>Especialidade:</strong> {rec.expertise_name || rec.expertise?.name || '—'}</p>
                  <p><strong>Status:</strong> {rec.pending ? 'Pendente' : 'Concluído'}</p>
                  <p><strong>Regulamento:</strong> {rec.regulation || '—'}</p>
                  <p><strong>Local:</strong> {rec.local || "-"}</p>
                  <p><strong>Pago por:</strong> {rec.paid_by || "-"}</p>
                  <p><strong>Motivo:</strong> {rec.reason || "-"}</p>
                  {hasBinaryField(rec, 'file') && (
                    <BinaryFileLink resource={BINARY_RESOURCES.internalForwarding} id={rec.id} field="file">Ver Documento</BinaryFileLink>
                  )}
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );

  const renderTabContent = () => {
    switch (currentTab) {
      case 'encaminhamento':
        return renderForwardingTab();
      default:
        return null;
    }
  };

  // --- Renderização principal do componente ---
  return (
    <div>
      <Sidebar />
      <Header />
      <div className="container social-container">
        <Titulo
          children={
            <SearchInternal
              onSelect={handleInternalSelect}
              onSelectingChange={setIsSelectingInternal}
            />
          }
        />

        {/* <h4 className="h4-title">Encaminhamento</h4> */}
        {isSelectingInternal ? (
          <InternalDataSkeleton />
        ) : (
          <>
        <div className="content-topo">
          <div className="content-img">
            <InternalPhoto internal={internalDetails} alt="Foto interno" />
          </div>
          <div className="content-itens">
            <div>
              {internalDetails?.name ? (
                <p><strong>Nome:</strong> {internalDetails.name}</p>
              ) : (
                <p><strong>Nome:</strong></p>
              )}
              {internalDetails?.social_name ? (
                <p><strong>Nome social:</strong> {internalDetails.social_name}</p>
              ) : (
                <p><strong>Nome social:</strong></p>
              )}
              {internalDetails?.aka ? (
                <p><strong>Vulgo:</strong> {internalDetails.aka}</p>
              ) : (
                <p><strong>Vulgo:</strong></p>
              )}
              {internalDetails?.cpf ? (
                <p><strong>CPF:</strong> {internalDetails.cpf}</p>
              ) : (
                <p><strong>CPF:</strong></p>
              )}
            </div>
            <div>
              {internalDetails?.unit_acronym ? (
                <p><strong>Unidade:</strong> {internalDetails.unit_acronym}</p>
              ) : (
                <p><strong>Unidade:</strong></p>
              )}
              {internalDetails?.pavilion_name ? (
                <p><strong>Pavilhão:</strong> {internalDetails.pavilion_name}</p>
              ) : (
                <p><strong>Pavilhão:</strong></p>
              )}
              {internalDetails?.cell_name ? (
                <p><strong>Cela:</strong> {internalDetails.cell_name}</p>
              ) : (
                <p><strong>Cela:</strong></p>
              )}
              {internalDetails?.conduct ? (
                <p><strong>Conduta:</strong> {internalDetails.conduct.name || ''}</p>
              ) : (
                <p><strong>Conduta:</strong></p>
              )}
            </div>
          </div>
        </div>

        <div className="social-tabs">
          <button className={`social-tab-button ${currentTab === 'encaminhamento' ? 'active' : ''}`} onClick={() => setCurrentTab('encaminhamento')}>Encaminhamento</button>
        </div>

        <div className="social-tab-content">
          {renderTabContent()}
        </div>
          </>
        )}

        {editForwardingData && (
          <Modal
            isOpen={!!editForwardingData}
            closeModal={() => setEditForwardingData(null)}
            title="Editar Encaminhamento"
          >
            <form onSubmit={handleUpdateForwarding} className="evolucao-container">
              <div className="social-form-group-duplo">
                {/* Tipo */}
                <div className="social-form-group">
                  <label>Tipo</label>
                  <select
                    name="type"
                    value={editForwardingData.type || ""}
                    onChange={(e) =>
                      setEditForwardingData({
                        ...editForwardingData,
                        type: e.target.value,
                      })
                    }
                  >
                    <option value="">Selecione</option>
                    <option value="Exames">Exames</option>
                    <option value="Consultas">Consultas</option>
                  </select>
                </div>

                {/* Especialidade */}
                <div className="social-form-group">
                  <label>Especialidade</label>
                  <select
                    name="expertise"
                    value={editForwardingData.expertise || ""}
                    onChange={(e) =>
                      setEditForwardingData({
                        ...editForwardingData,
                        expertise: parseInt(e.target.value, 10) || "",
                      })
                    }
                  >
                    <option value="">Selecione</option>
                    {expertise.map((ex) => (
                      <option key={ex.id} value={ex.id}>
                        {ex.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="social-form-group">
                <label>Regulamento</label>
                <textarea
                  name="regulation"
                  value={editForwardingData.regulation || ""}
                  onChange={(e) =>
                    setEditForwardingData({
                      ...editForwardingData,
                      regulation: e.target.value,
                    })
                  }
                />
              </div>

              <div className="social-form-group">
                <label>Motivo</label>
                <textarea
                  name="reason"
                  value={editForwardingData.reason || ""}
                  onChange={(e) =>
                    setEditForwardingData({
                      ...editForwardingData,
                      reason: e.target.value,
                    })
                  }
                />
              </div>

              <div className="social-form-group-duplo">
                <div className="social-form-group">
                  <label>Local</label>
                  <input
                    type="text"
                    name="local"
                    value={editForwardingData.local || ""}
                    onChange={(e) =>
                      setEditForwardingData({
                        ...editForwardingData,
                        local: e.target.value,
                      })
                    }
                  />
                </div>

                <div className="social-form-group">
                  <label>Pago por</label>
                  <select
                    name="paid_by"
                    value={editForwardingData.paid_by || ""}
                    onChange={(e) =>
                      setEditForwardingData({
                        ...editForwardingData,
                        paid_by: e.target.value,
                      })
                    }
                  >
                    <option value="">Selecione</option>
                    <option value="SUS">SUS</option>
                    <option value="FAMILIA">Família</option>
                  </select>
                </div>
              </div>

              <div className="social-form-group">
                <label>Pendente</label>
                <select
                  name="pending"
                  value={editForwardingData.pending ? "true" : "false"}
                  onChange={(e) =>
                    setEditForwardingData({
                      ...editForwardingData,
                      pending: e.target.value === "true",
                    })
                  }
                >
                  <option value="true">Sim</option>
                  <option value="false">Não</option>
                </select>
              </div>

              <div className="social-form-group">
                <button type="submit" className="social-submit-button" disabled={isUpdatingForwarding}>
                  {isUpdatingForwarding ? 'Salvando...' : 'Salvar Alterações'}
                </button>
              </div>
            </form>
          </Modal>
        )}
      </div>
    </div>
  );
};

export default Encaminhamento;
